import mock from 'src/utils/mock';
import { LabMemberShip as LabMemberShipinterface } from 'src/types/labMemberShip';
const labMemberShip: LabMemberShipinterface[] = [
    {
        RegLabID: 9001,
        SubCenterID: 0,
        SubCenterType: 'Main Lab',
        TypeID: 103,
        MemberShipName: 'Gold',
        Remarks: 'This is a sample Mapping',
        JoinningDt: '2023-07-19T16:57:05.537Z',
        ValidFrom: '2023-07-19T16:57:05.537Z',
        ValidUpto: '2024-07-18T16:57:05.537Z',
        Rev_No: 23,
        ID: 1,
    },
];

mock.onPost('/getMemList/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, labMemberShip]);
        }, 1000);
    });
});

mock.onPost('/getMemDetail/').reply((config) => {
    const params = JSON.parse(config.data);
    const labMemberShipData = labMemberShip.filter((item) => item.ID === params.id)[0];
    return [200, { ...labMemberShipData }];
});
